module.exports = __webpack_public_path__ + "img/text.e306f49b.svg";